'use client';

import { ChangeEvent, useEffect, useState } from 'react';

const useComment = (initialValue: string) => {
  const [value, setValue] = useState<string>(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const onChange = (e: ChangeEvent<HTMLTextAreaElement> | string) => {
    if (typeof e === 'string') return setValue(e);

    const { value: incomingValue } = e.target;

    setValue(incomingValue);
  };

  const onReset = () => {
    setValue(initialValue);
  };

  return [value, onChange, onReset] as const;
};

export default useComment;
